const initialState = {
  documentLabelPanelOn: false
}


export const documentLabelPanelReducer = (state = initialState, action) => {
  switch (action.type) {

    case "SET_DOCUMENTLABELPANELACTION": {
      return { ...state, documentLabelPanelOn: action.data }
    }

    default:
      return state;

  }
};